module.exports = __webpack_public_path__ + "static/media/icon-kcal.021ce348.svg";